
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Looks5OutlinedIcon from '@material-ui/icons/Looks5Outlined';

import { AppBar, Grid, IconButton, Button, Typography, TextField, InputAdornment, Select, MenuItem, CircularProgress, Snackbar } from '@material-ui/core';
import AppConfig from '../../control/config';
import DeviceEventEmitter, { EventName } from '../../control/event';
import ErrorCode from '../../network/errorcode';
import MBackIcon from '../view/MBackIcon';
import AppUtils from '../../control/apputlis';

const SEND_VERIFY_CODE = '获取验证码';

const styles = (theme) => (
    {
        root: {
            width: '100vw',
            height: '100vh',
            display: "flex",
            flexDirection: "column",
            alignItems: 'center',
        },
        appbar: {
            top: 0,
            backgroundColor: 'transparent',
            height: 48,
            boxShadow: 'none'
        },
        titleGrid: {
            padding: theme.spacing(7, 4, 5, 4),
            color: 'black',
        },
        paperTop: {
            paddingTop: 45,
            backgroundColor: theme.palette.background.default,
        },
        textfield: {
            margin: theme.spacing(3, 0, 1, 0),
            color: '#000000',
            fontSize: 22,
            height: 30,
        },
        select: {
            margin: theme.spacing(0, 0, 0, 0),
        },
        titleLabel: {
            margin: theme.spacing(0, 1, 0, 1),
            fontSize: 18,
            width: 60,
        },
        loginBtn: {
            backgroundColor: theme.palette.secondary.main,
            borderRadius: 25,
            color: 'white',
            height: 50,
            width: "calc(100vw - 32px)",
            margin: theme.spacing(5, 0, 2, 0),
            fontSize: 20,
        },
    }
);

class ForgetPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            areaCode: 86,
            phonenum: '',
            phone_valid: false,
            password: '',
            login_failed: false,
            showLoading: false,
            showPassword: false,
            password2: '',
            code: '',
            snackopened: false,
            message: '',
            verifyCodeLeftTime: 0,
            isVerifyCodeRequesting: false,
            verifyCodeBtnTitle: SEND_VERIFY_CODE,
        };

        this._onAreaCodeSelected = this._onAreaCodeSelected.bind(this);
        this._onClickShowPassword = this._onClickShowPassword.bind(this);
        this._submitLoginCredentials = this._submitLoginCredentials.bind(this);
        this._onRegisterSuccess = this._onRegisterSuccess.bind(this);
        this._onRegisterFailed = this._onRegisterFailed.bind(this);
        this._onVerifyCodeClick = this._onVerifyCodeClick.bind(this);
        this._verifyCodeTimeAction = this._verifyCodeTimeAction.bind(this);
    }

    validatePhone(phone) {
        var re = /^1(3|4|5|7|8)\d{9}$/;

        return re.test(phone);
    }

    _submitLoginCredentials() {
        const { phonenum, password, password2, code, showLoading } = this.state;
        if (!showLoading) {
            if (!this.validatePhone(phonenum)) {
                this.setState({ message: '请正确填写手机号码', snackopened: true });
                return;
            }
            if (!password || password === '' || !password2 || password2 === '') {
                this.setState({ message: '密码不能为空', snackopened: true });
                return;
            }
            if (!code || code === '') {
                this.setState({ message: '验证码不能为空', snackopened: true });
                return;
            }
            if (password !== password2) {
                this.setState({ message: '两次输入的密码不一致', snackopened: true });
                return;
            }

            this.setState({
                showLoading: !showLoading
            });

        }
    }

    _onVerifyCodeClick() {
        if (this.state.isVerifyCodeRequesting || this.state.verifyCodeLeftTime > 0) {
            return;
        }
        const phonenum = this.state.phonenum;
        if (!this.validatePhone(phonenum)) {
            this.setState({ message: '请正确填写手机号码', snackopened: true });
            return;
        }
        this.setState({
            isVerifyCodeRequesting: true,
            verifyCodeBtnTitle: '',
        });

    }

    _verifyCodeTimeAction() {
        const codeTime = 60;
        this.setState({
            verifyCodeLeftTime: codeTime,
            isVerifyCodeRequesting: false,
            verifyCodeBtnTitle: codeTime + 's',
        });
        const now = Date.now()
        const overTimeStamp = now + codeTime * 1000 + 100/*过期时间戳（毫秒） +100 毫秒容错*/
        this.interval = setInterval(() => {
            /* 切换到后台不受影响*/
            const nowStamp = Date.now()
            if (nowStamp >= overTimeStamp) {
                /* 倒计时结束*/
                this.interval && clearInterval(this.interval);
                this.setState({
                    verifyCodeLeftTime: 0,
                    verifyCodeBtnTitle: SEND_VERIFY_CODE,
                    isVerifyCodeRequesting: false,
                    // selfEnable: true
                });
            } else {
                const leftTime = parseInt((overTimeStamp - nowStamp) / 1000, 10)
                this.setState({
                    verifyCodeLeftTime: leftTime,
                    verifyCodeBtnTitle: `${leftTime}s`,
                });
            }
        }, 1000);
    }

    componentDidMount() {
        DeviceEventEmitter.on(EventName.FORGET_PWD_SUCCESS, this._onRegisterSuccess, this);
        DeviceEventEmitter.on(EventName.FORGET_PWD_FAILED, this._onRegisterFailed, this);
        AppUtils.YMPush('MAIN', 'ForgetPage');
    }

    componentWillUnmount() {
        DeviceEventEmitter.off(EventName.FORGET_PWD_SUCCESS, this._onRegisterSuccess, this);
        DeviceEventEmitter.off(EventName.FORGET_PWD_FAILED, this._onRegisterFailed, this);
        clearInterval(this.interval)
    }

    _onRegisterSuccess(e) {
        console.log("_onRegisterSuccess", e);
        this.setState({ message: '找回密码成功！', snackopened: true });
        window.history.back();
    }

    _onRegisterFailed(e) {
        let errMsg = '';
        switch (e) {
            case ErrorCode.CODE_VERIFY_CODE_ERROR:
                errMsg = '验证码错误';
                break;
            case ErrorCode.CODE_PWD_LEN_ERROR:
                errMsg = '密码长度不符';
                break;
            default:
                errMsg = '修改失败:' + e;
                break;
        }
        this.setState({ message: errMsg, snackopened: true });
        this.setState({
            showLoading: false
        });
    }

    _onAreaCodeSelected(event) {
        this.setState({
            areaCode: event.target.value,
        })
    }

    _onClickShowPassword(event) {
        const { showPassword } = this.state;
        this.setState({
            showPassword: !showPassword,
        })
    }

    render() {
        const { classes } = this.props;
        const { snackopened, message, phonenum, areaCode, password, password2, showLoading, code, verifyCodeBtnTitle, isVerifyCodeRequesting, showPassword } = this.state;
        return (
            <React.Fragment>
                <div className={classes.root}>
                    <AppBar className={classes.appbar} color="primary">
                        <Grid justifyContent='space-between' container>
                            <MBackIcon />
                        </Grid>
                    </AppBar>
                    <div style={{ height: 10 }}></div>
                    <Grid className={classes.titleGrid}>
                        <Typography variant='h3'>{AppConfig.APP_NAME}</Typography>
                        <Typography variant='h6'>找回密码</Typography>

                        <TextField
                            className={classes.textfield}
                            fullWidth
                            id="accountTextField"
                            placeholder="请输入手机号"
                            value={phonenum}
                            type='tel'
                            onChange={event => this.setState({ phonenum: event.target.value, phone_valid: this.validatePhone(event.target.value) })}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <PhoneAndroidIcon style={{ color: '#ffffff99' }} />
                                        <Select
                                            id="areacode-select"
                                            value={areaCode}
                                            onChange={this._onAreaCodeSelected}
                                            className={classes.select}
                                        >
                                            <MenuItem value={86}>+86</MenuItem>
                                            <MenuItem value={10}>+10</MenuItem>
                                            <MenuItem value={20}>+20</MenuItem>
                                            <MenuItem value={30}>+30</MenuItem>
                                        </Select>
                                    </InputAdornment>
                                ),
                            }}
                            inputProps={{
                                maxLength: 11,
                            }}
                        />
                        <TextField
                            className={classes.textfield}
                            fullWidth
                            id="codeTextField"
                            placeholder="数字验证码"
                            type={'tel'}
                            value={code}
                            onChange={event => this.setState({ code: event.target.value })}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Looks5OutlinedIcon style={{ color: '#ffffff99' }} />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Button
                                            style={{ width: 120 }}
                                            startIcon={isVerifyCodeRequesting ? <CircularProgress size={26} /> : null}
                                            onClick={this._onVerifyCodeClick}>
                                            {verifyCodeBtnTitle}
                                        </Button>
                                    </InputAdornment>
                                )
                            }}
                            inputProps={{
                                maxLength: 6,
                            }}
                        />
                        <TextField
                            className={classes.textfield}
                            fullWidth
                            id="passwordTextField"
                            placeholder="6-18位数字或字母"
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={event => this.setState({ password: event.target.value })}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LockOpenIcon style={{ color: '#ffffff99' }} />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={this._onClickShowPassword}
                                        >
                                            {showPassword ? <Visibility style={{ color: '#ffffff99' }} /> : <VisibilityOff style={{ color: '#ffffff99' }} />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                            inputProps={{
                                maxLength: 18,
                            }}
                        />
                        <TextField
                            className={classes.textfield}
                            fullWidth
                            id="password2TextField"
                            placeholder='请再次输入密码'
                            type={showPassword ? 'text' : 'password'}
                            value={password2}
                            onChange={event => this.setState({ password2: event.target.value })}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LockOutlinedIcon style={{ color: '#ffffff99' }} />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={this._onClickShowPassword}
                                        >
                                            {showPassword ? <Visibility style={{ color: '#ffffff99' }} /> : <VisibilityOff style={{ color: '#ffffff99' }} />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                            inputProps={{
                                maxLength: 18,
                            }}
                        />
                        <Grid container justifyContent='center' >
                            <Button
                                className={classes.loginBtn}
                                onClick={this._submitLoginCredentials}
                                startIcon={
                                    showLoading ? <CircularProgress size={26} /> : null
                                }
                            >确  认</Button>
                        </Grid>

                    </Grid>
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        open={snackopened}
                        onClose={() => this.setState({ snackopened: false })}
                        message={message}
                        autoHideDuration={3000}>
                    </Snackbar>
                </div>
            </React.Fragment>

        );
    }
}

export default withStyles(styles)(ForgetPage);